<template>
    <a-drawer width="50%" :label-col="4" :wrapper-col="14" :maskClosable="false" :visible="open" @close="onClose">
        <a-divider orientation="left">
            <b>{{ formTitle }}兑换码</b>
        </a-divider>
        <a-form-model ref="form" :model="form" :rules="rules">

            <a-form-model-item label="兑换码" prop="code">
                <a-input v-model="form.code" :maxLength="6" placeholder="手动输入6位大小写数字" :disabled="formType === 2" />
            </a-form-model-item>

            <a-form-model-item label="分配权限" prop="privilegeType">
                <a-select v-model="form.privilegeType" placeholder="请选择权限项 (可多选)" mode="multiple" allowClear>
                    <a-select-option value="faceSwap">
                        faceSwap
                    </a-select-option>
                    <a-select-option value="actionVideo">
                        actionVideo
                    </a-select-option>
                </a-select>
            </a-form-model-item>

            
            <a-form-model-item label="使用次数" prop="usageLimit">
                <a-input-number v-model="form.usageLimit" placeholder="请输入兑换码可使用次数（不填为无限制使用次数）" :disabled="formType === 2" />
            </a-form-model-item>

            <a-form-model-item label="开始时间" prop="startTime">
                <a-date-picker :allow-clear="true" size="default" v-model="form.startTime" placeholder="开始时间"
                    value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
                </a-date-picker>
            </a-form-model-item>

            <a-form-model-item label="截止时间" prop="endTime">
                <a-date-picker :allow-clear="true" size="default" v-model="form.endTime" placeholder="截止时间"
                    value-format="YYYY-MM-DD HH:mm" format="YYYY-MM-DD HH:mm">
                </a-date-picker>
            </a-form-model-item>

            <a-form-model-item label="启用状态" prop="status">
                <a-select v-model="form.status" placeholder="请选择">
                    <a-select-option :value="0">启用</a-select-option>
                    <a-select-option :value="1">禁用</a-select-option>
                </a-select>
            </a-form-model-item>
            

            <div class="bottom-control">
                <a-space>
                    <a-button type="primary" :loading="submitLoading" @click="submitForm">
                        保存
                    </a-button>
                    <a-button type="dashed" @click="cancel">
                        取消
                    </a-button>
                </a-space>
            </div>
        </a-form-model>
    </a-drawer>
</template>

<script>
import { detail, addOrUpdate } from '@/api/privilegeCode/privilegeCode'

export default {
    name: 'PrivilegeCodeCreateForm',
    data() {
        // 验证规则
        const validateCode = (rule, value, callback) => {

            // 严格的正则表达式：
            // 1. ^[a-zA-Z0-9]{6}$ : 必须是6位大小写字母或数字
            // 2. (?=.*[a-z])      : 必须包含至少一个小写字母 (Positive Lookahead)
            // 3. (?=.*[A-Z])      : 必须包含至少一个大写字母 (Positive Lookahead)
            // 4. (?=.*[0-9])      : 必须包含至少一个数字 (Positive Lookahead)
            const strictRegex = /^(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])[a-zA-Z0-9]{6}$/;

            if (!value) {
                callback(new Error('兑换码不能为空'));
            } else if (!strictRegex.test(value)) {
                callback(new Error('兑换码必须是6位，且同时包含大小写字母和数字'));
            } else {
                callback();
            }
        };

        return {
            // ** 移除了 privilegeItems 数组 **
            submitLoading: false,
            formTitle: '',

            form: {
                id: null,
                code: null,
                privilegeType: [], // 默认值仍需保持为数组
                status: null,
                usageLimit: null
            },
            formType: 1,
            open: false,
            rules: {
                code: [{ required: true, validator: validateCode, trigger: 'blur' }],
                // 多选模式下，验证类型为 array
                privilegeType: [{ required: true, type: 'array', message: '请选择权限项', trigger: 'change' }]
            }
        }
    },
    methods: {
        onClose() {
            this.reset();
            this.open = false
        },
        cancel() {
            this.reset()
            this.open = false
        },
        reset() {
            this.formType = 1
            this.form = {
                id: null,
                code: null,
                privilegeType: [], // 重置时清空数组
                status: null,
                startTime: null,
                endTime: null,
                usageLimit: null
            }
            this.$nextTick(() => {
                if (this.$refs.form) {
                    this.$refs.form.resetFields()
                    this.form.privilegeType = []; // 确保重置后是空数组
                }
            })
        },

        handleAdd() {
            this.reset()
            this.formType = 1
            this.open = true
            this.formTitle = '新增'
        },

        handleUpdate(row) {
            this.reset()
            this.formType = 2
            const id = row.id

            detail({ id: id }).then(response => {
                this.form = response.data

                // 将后端返回的逗号分隔字符串转为数组
                if (this.form.privilegeType && typeof this.form.privilegeType === 'string') {
                    this.form.privilegeType = this.form.privilegeType.split(',');
                } else {
                    this.form.privilegeType = [];
                }

                this.open = true
                this.formTitle = '修改'
            })
        },

        submitForm: function () {
            this.$refs.form.validate(valid => {
                if (valid) {
                    this.submitLoading = true

                    // 将数组转换为逗号分隔的字符串提交给后端
                    const dataToSend = { ...this.form };
                    if (Array.isArray(dataToSend.privilegeType)) {
                        dataToSend.privilegeType = dataToSend.privilegeType.join(',');
                    }

                    addOrUpdate(dataToSend).then(response => {
                        this.$message.success(
                            this.form.id ? '修改成功' : '新增成功',
                            3
                        )
                        this.open = false
                        this.$emit('ok')
                    }).finally(() => {
                        this.submitLoading = false
                    })
                } else {
                    return false
                }
            })
        }
    }
}
</script>

<style scoped>
.bottom-control {
    text-align: right;
    padding-top: 10px;
}
</style>